export default "__VITE_ASSET__CMic7thw__"